import router from "../router";
import Axios from "axios";
import Moment from "moment";
import store from "../store";
import * as Cookies from 'tiny-cookie'

import provinces from "./provinces";
import { i18n } from "../lang/i18n-core.js";

var baseUrl = process.env.VUE_APP_BASEURL + ":" + process.env.VUE_APP_BASEURLPORT + "/api/dashboard/";
if (process.env.NODE_ENV != "development") {
	baseUrl = process.env.VUE_APP_BASEURL;
	window.baseUrl = process.env.VUE_APP_BASEURL;
} else {
	window.baseUrl = process.env.VUE_APP_BASEURL + ":" + process.env.VUE_APP_BASEURLPORT;
} 

const BANK_FLAG_YES = "yes";

const instance = Axios.create({
	baseURL: baseUrl,
	timeout: 60000,
});

var controlTimeout = null;

var helper = {
	tinyMCEKey() {
		return process.env.VUE_APP_TINYMCE;
	},

	openLoader() {
		store.commit("loading", true);
	},

	closeLoader() {
		store.commit("loading", false);
	},

	cloneObject(object) {
		return JSON.parse(JSON.stringify(object));
	},

	callback_error(error) {
		this.closeLoader();

		let msg = "Error Processing Request";

		if (typeof error.response == "undefined") {
			// erro não tratável. Um problema de sintaxe ou de server não retornando um json
			alert(msg);
			console.error(error);
			return;
		}

		if (typeof error.response.data == "undefined") {
			if (typeof error.ERRO != "undefined") {
				msg = error.ERRO;
			} else {
				msg = "Error Processing Request";
			}
		} else {
			if (typeof error.response.data.ERRCODE != "undefined") {

				// Erro de login - usuário não logado
				if (error.response.data.ERRCODE == 7) {
					this.pushRouteTo({ name: "Login" });
					return;
				} else if (error.response.data.ERRO.indexOf("Your username has been locked") >= 0) {
					// Caso do usuário que teve que confirmar a senha na modal, porém bloqueou a senha
					alert(error.response.data.ERRO);
					this.pushRouteTo({ name: "Login" });
					return;
				} else if (error.response.data.ERRO.indexOf("Permission denied") >= 0) {
					// erro de permissão // volte uma casa
					clearTimeout(controlTimeout);
					controlTimeout = window.setTimeout(function () {
						alert(error.response.data.ERRO);
						router.go(-1);
					}, 100);

					return;
				} else {
					msg = error.response.data.ERRO;
				}
			} else if (typeof error.response.data.error != "undefined") {
				msg = error.body.error;
			}
		}

		if (typeof msg === "string" && msg.indexOf("group.") === 0) {
			msg = i18n.t(msg);
		}

		alert(msg);
	},

	pushRouteTo(route) {
		// if sending path:
		if (typeof route == "string") {
			if (router.history.current.path != route) {
				router.push(route).catch(err => {
					// ignora erros de duplicidade no direcionamento para o mesmo path. Mesmo com o if acima, ele pode ocorrer.
					if (
						err.name !== 'NavigationDuplicated' &&
						!err.message.includes('Avoided redundant navigation to current location')
					) {
						// Outros erros, ele loga
						console.error(err);
					}
				});
			}
		} else { // if sending a {name: '', ...}
			if (router.history.current.path != route.name) {
				router.push(route).catch(err => {
					// ignora erros de duplicidade no direcionamento para o mesmo path. Mesmo com o if acima, ele pode ocorrer.
					if (
						err.name !== 'NavigationDuplicated' &&
						!err.message.includes('Avoided redundant navigation to current location')
					) {
						// Outros erros, ele loga
						console.error(err);
					}
				});
			}
		}
	},

	axios() {
		return instance;
	},

	exportCSVFile(headers, items, fileTitle) {
		// Coloca como a primeira linha dos itens, o cabeçalho
		if (headers) {
			items.unshift(headers);
		}

		// Convert Object to JSON
		let jsonObject = JSON.stringify(items);
		let csv = this.convertToCSV(jsonObject);
		let exportedFilenmae = fileTitle + ".csv" || "export.csv";

		// Cria o objeto que será feito o download
		let blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

		// IE 10+
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(blob, exportedFilenmae);
		} else {
			// Navegadores standarts HTML5
			let link = document.createElement("a");

			if (link.download !== undefined) {
				// feature detection
				// Browsers that support HTML5 download attribute
				let url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", exportedFilenmae);
				link.style.visibility = "hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	},

	generateFormData(systemName=null, className, methodName, params=[], defaultData=true){
		const formData = new FormData();

		formData.append("system",	systemName);
		formData.append("class",	className);
		formData.append("method",	methodName);

		if(defaultData){
			formData.append("username",	Cookies.get("username"));
			formData.append("token",	Cookies.get("token"));
			formData.append("xpp",		Cookies.get("xpp"));
		}

		Object.keys(params).forEach((index) => {
			formData.append(index, params[index]);
		});

		return formData;
	},

	hideUpdateButton(fields, system) {
		let hiddenUpdate = false;
		let find;

		fields.forEach(field => {
			// Compara campos e retorna os que estejam inclusos no sistema.
			find = system.find(el => {
				return el.campo == field;
			})

			if (typeof find != "undefined") {
				// Valida permissão de insert dos campos
				if (parseInt(find.insert) != 0) {
					hiddenUpdate = true;
				}
			}
		})
		
		return hiddenUpdate;
	},

	/**
	 * Formata a data para o padrão dd/MM ou MM/dd, conforme
	 * o formato selecionado.
	*/
	formatDayMonth(format, value) {
		let newValue = value;

		if (typeof value == "undefined" || value == null || value == "") {
			return "";
		}

		let split = value.split("-");

		newValue = split[0]+"/"+split[1];
		if (format == 1) {
			newValue = split[1]+"/"+split[0];
		}

		return newValue;
	},

	formatDate(format, valor) {
		let split;

		if (typeof valor == "undefined" || valor == null) {
			return "";
		}

		if (format == 1 && valor != "" && valor != null) {
			if (valor.indexOf("-") != -1) {
				split = "-";
			} else {
				split = "/";
			}

			let info = valor.split(split);

			if (info[2].length < 4) {
				// provavelmente o formato é YYYY-MM-DD
				valor = Moment(valor, "YYYY" + split + "MM" + split + "DD");
			} else {
				// provavelmente o formato é MM-DD-YYYY
				valor = Moment(valor, "MM" + split + "DD" + split + "YYYY");
			}

			info = valor.format("DD/MM/YYYY");

			return info;
		} else {
			// Quando o dado vem através do miva, ele já vem formatado com MM/DD/YYYY
			// Entretanto, quando vem via mysql, ele vem como YYYY-MM-DD, e precisa ser formatado
			if (valor != null && valor.indexOf("-") == -1) {
				return valor;
			}

			valor = Moment(valor, "YYYY-MM-DD");
			let info = valor.format("MM/DD/YYYY");

			return info;
		}
	},

	formatTimestamp(format, valor) {
		if (typeof valor == "undefined" || valor == null) {
			return "";
		}

		let info;
		if (format == 1 && valor != "" && valor != null) {
			// provavelmente o formato é YYYY-MM-DD
			valor = Moment(valor, "YYYY-MM-DD HH:mm:ss");

			info = valor.format("DD/MM/YYYY HH:mm:ss");

			return info;
		} else {
			// Quando o dado vem através do miva, ele já vem formatado com MM/DD/YYYY
			// Entretanto, quando vem via mysql, ele vem como YYYY-MM-DD, e precisa ser formatado
			if (valor != null && valor.indexOf("-") == -1) {
				return valor;
			}

			valor = Moment(valor, "YYYY-MM-DD HH:mm:ss");
			let info = valor.format("MM/DD/YYYY HH:mm:ss");

			return info;
		}
	},

	formatValue(format, valor, length = 2){
		if(typeof valor == "undefined" || valor == null){
			return '';
		}

		if(valor == ''){
			valor = 0.00;
		}

		let value = parseFloat(valor);

		let thousands_separator	= ',';
		let decimal_separator	= '.';

		if(format == 1){
			thousands_separator	= '.';
			decimal_separator	= ',';
		}

		return value.format(length, 3, thousands_separator, decimal_separator);
	},

	formatValueDefaultHifen(format, valor, length = 2){
		let amount = this.formatValue(format, valor, length);

		if(parseFloat(valor) == 0 || amount == ''){
			return '-';
		}

		return amount;
	},

	formatValueToNegative(format, valor, length = 2){
		if(typeof valor == "undefined" || valor == null){
			return '';
		}

		if(valor == ''){
			valor = 0.00;
		}

		let value = parseFloat(valor);
		let thousands_separator = ',';
		let decimal_separator = '.';

		if(format == 1){
			thousands_separator = '.';
			decimal_separator = ',';
		}

		if(valor == 0.00){
			return value.format(length, 3, thousands_separator, decimal_separator);
		}

		return '- ' + value.format(length, 3, thousands_separator, decimal_separator);
	},

	parseQuery(queryString) {
		let query = {};
		let pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
		for (let i = 0; i < pairs.length; i++) {
			let pair = pairs[i].split("=");
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
		}
		return query;
	},

	popup(popup, URL) {
		/*let width 	= 500;
		let height 	= 500;
		let left 	= 99;
		let top 	= 99;

		window.open(URL, 'janela', 'width='+width+', height='+height+', top='+top+', left='+left+', scrollbars=yes, status=no, toolbar=no, location=no, directories=no, menubar=no, resizable=no, fullscreen=no');
		*/

		popup.location.href = URL;
	},

	copyToClipboard(texto) {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(texto);
		} else {
			this.copyToClipboardFallBack(texto);
		}
	},

	copyToClipboardFallBack(texto) {
		let $temp = document.createElement("textarea");
		document.querySelector("body").appendChild($temp);
		$temp.value = texto;

		if (navigator.userAgent.match(/ipad|iphone/i)) {
			var range, selection;

			let input_aux = $temp.get(0);

			range = document.createRange();
			range.selectNodeContents(input_aux);
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			input_aux.setSelectionRange(0, 999999);
		} else {
			//textarea.select();
			$temp.select();
		}

		document.execCommand("copy");
		$temp.remove();
	},

	convertToCSV(objArray) {
		var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
		var str = "";

		for (var i = 0; i < array.length; i++) {
			var line = "";

			for (var index in array[i]) {
				if (line != "") {
					line += ";";
				}

				var aux = array[i][index];

				if (typeof aux != "object") {
					line += '"' + String(aux).replace(/;/g, "") + '"';
				}
			}

			str += line + "\r\n";
		}

		return str;
	},

	validaTaxId(taxId){
		taxId = (taxId || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
		let add, rev, i, r;

		if(taxId < 11){
			return null;
		}

		//Verifica os digitos repetidos de 0 a 9 para 11 e 14 digitos.
		for(r=0; r <= 9; r ++){
			var str11 = "###########".replace(/#/gi, r);
			var str14 = "##############".replace(/#/gi, r);

			if(taxId == str11 || taxId == str14) {
				return false;
			}
		}

		if(taxId.length == 11){
			// Valida 1o digito
			add = 0;
			for(i=0; i < 9; i ++){
				add += parseInt(taxId.charAt(i)) * (10 - i);
			}

			rev = 11 - (add % 11);
			if(rev == 10 || rev == 11){
				rev = 0;
			}

			if(rev != parseInt(taxId.charAt(9))){
				return false;
			}

			// Valida 2o digito
			add = 0;
			for(i = 0; i < 10; i ++){
				add += parseInt(taxId.charAt(i)) * (11 - i);
			}

			rev = 11 - (add % 11);
			if(rev == 10 || rev == 11){
				rev = 0;
			}

			if(rev != parseInt(taxId.charAt(10))){
				return false;
			}

			return true;

		} else if(taxId.length == 14){

			let tamanho, numeros, digitos, soma, pos, resultado;

			// Valida DVs
			tamanho = taxId.length - 2;
			numeros = taxId.substring(0,tamanho);
			digitos = taxId.substring(tamanho);
			soma = 0;
			pos = tamanho - 7;

			for(i = tamanho; i >= 1; i--){
				soma += (numeros.charCodeAt(tamanho - i) - 48) * pos--;
				if(pos < 2){
					pos = 9;
				}
			}

			resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
			if(resultado != digitos.charAt(0)){
				return false;
			}

			tamanho = tamanho + 1;
			numeros = taxId.substring(0,tamanho);
			soma = 0;
			pos = tamanho - 7;

			for(i = tamanho; i >= 1; i--){
				soma += (numeros.charCodeAt(tamanho - i) - 48) * pos--;
				if(pos < 2){
					pos = 9;
				}
			}

			resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
			if(resultado != digitos.charAt(1)){
				return false;
			}

			return true;
		}

		return false;
	},

	formatXML(val) {
		return vkbeautify.xml(val);
	},

	formatJSON(val) {
		return vkbeautify.json(val);
	},

	removeTaxIdSpecialChars(value) {
		return (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
	},

	formatTaxid(value) {
		let taxId = this.removeTaxIdSpecialChars(value);

		// Verifica se o valor é numérico para formatar CPF.
		let isNumeric = /^\d+$/.test(taxId);
		let isCPF = isNumeric && taxId.length <= 11;

		// Valida se é CPF ou CNPJ e formata em tempo real, enquanto o usuário digita.
		if (isCPF) {
			return taxId
				.replace(/^(\d{3})(\d)/, '$1.$2')
				.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
				.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
		} else {
			// Restringe os dois últimos dígitos a numérico antes de formatar
			taxId = taxId.slice(0, 12) + taxId.slice(12).replace(/[^0-9]/g, '').slice(0, 2);

			return taxId
				.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
				.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
				.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4')
				.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
		}
	},

	formatPhone(value) {
		return value?.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
	},

	formatZip(value) {
		return value?.replace(/(\d{5})(\d{3})/, '$1-$2');
	},

	getProvinces() {
		return provinces;
	},

	getMessageFromErrorCode(error) {
		const map = {
			"00": "Error processing request",
			"01": "Declined by the issuing bank",
			"02": "Please ask the customer to contact the issuing bank",
			"03": "Card with restrictions; Please ask the customer to contact the issuing bank",
			"04": "Please try again",
			"05": "Declined by the issuing bank",
			"06": "Invalid amount",
			"07": "Invalid credit card number",
			"08": "Invalid issuing bank",
			"09": "Credit card limit exceeded",
			"10": "Expired credit card",
			"11": "Transaction not allowed by the bank",
			"12": "Credit card not activated; Please ask the customer to contact the issuing bank",
			"13": "Bank not available at the moment",
			"14": "Card not allowed for this type of transaction",
			"15": "Invalid CVV",
			"16": "Card not allowed for online purchases",
			"17": "Invalid installment plan",
			"19": "Invalid credit card expiration date"
		};

		return map[error] ?? "Undefined";
	},

	getMessageFromErrorType(type, $t) {
		const map = {
			"1": $t('ar_cancellation_lack_of_necessity_reason'),
			"2": $t('ar_cancellation_low_satisfaction_reason'),
			"3": $t('ar_cancellation_regret_reason'),
			"4": $t('ar_cancellation_another_reason')
		};

		return map[type] ?? "Undefined";
	},


	isBankActive(ativo) {
		return ativo === BANK_FLAG_YES;
	},

	getBankNumber(banco) {
		if (banco === null || banco === undefined || banco === "") {
			return "";
		}

		if (typeof banco === "object") {
			if (banco.value !== undefined && banco.value !== null && banco.value !== "") {
				return String(banco.value);
			}

			if (banco.numero !== undefined && banco.numero !== null && banco.numero !== "") {
				return String(banco.numero);
			}

			return "";
		}

		return String(banco);
	},

	/**
	 * Bancos ativos para cadastro novo, mais os números já salvos para o edit manter o nome completo.
	 * Linhas sem número (placeholder do select) entram sempre.
	 */
	filterBanksForSelect(bankRows, savedNumbers) {
		const saved = (savedNumbers || [])
			.map((numero) => this.getBankNumber(numero))
			.filter((numero) => numero !== "");

		return (bankRows || []).filter((row) => {
			const numero = this.getBankNumber(row);

			if (numero === "") {
				return true;
			}

			return this.isBankActive(row.ativo) || saved.includes(numero);
		});
	},

	downloadOctet(response){

		const filename = ('; '+document.cookie).split(`; exportFilename=`).pop().split(';')[0];

		const href = window.URL.createObjectURL(response.data);

		const link = document.createElement('a');
		link.href = href;
		link.setAttribute('download', filename);
		link.style.display = 'none';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		setTimeout(() => {
			window.URL.revokeObjectURL(href);
		}, 60000);
	},
};

export default helper;
